type Scope =
  | { kind: 'tenant'; tenantId: string }
  | { kind: 'site'; tenantId: string; siteId: string }
  | { kind: 'contractor'; tenantId: string; siteId: string; contractorId: string };

/** Preserve the selected server-issued reference; only the trusted server resolves aliases. */
export function operationalSelectedScopeId(scope: Scope): string | null {
  const identifier = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u;
  if (scope.tenantId !== 'kop') return null;
  if (scope.kind === 'tenant') return 'tenant:kop';
  if (typeof scope.siteId !== 'string' || !identifier.test(scope.siteId)) return null;
  if (scope.kind === 'site') return `site:${scope.siteId}`;
  return typeof scope.contractorId === 'string' && identifier.test(scope.contractorId)
    ? `site:${scope.siteId}/contractor:${scope.contractorId}` : null;
}

/** Home projections accept an explicit factory/contractor scope; HQ tenant scope stays unscoped. */
export function workspaceHomeSelectedScopeId(scope: Scope): string | null {
  return scope.kind === 'tenant' ? null : operationalSelectedScopeId(scope);
}
